export const MainNav = [
  {
    icon: 'pe-7s-rocket',
    label: 'Dashboard',
    to: '/dashboards/crm',
  },
];
export const PlanningAssessmentNav = [
  {
    icon: 'pe-7s-note2',
    label: 'New project',
    to: '/planning-assessement',
  },
  {
    icon: 'pe-7s-folder',
    label: 'My plannings',
    to: '/planning-assessement/my-plannings',
  },
];
export const ControlNav = [
  {
    icon: 'pe-7s-users',
    label: 'Users',
    to: '/dashboards/crm/users',
  },
];
export const ComponentsNav = [
  {
    icon: 'pe-7s-diamond',
    label: 'Elements',
    content: [
      {
        label: 'Standard Buttons',
        to: '/elements/buttons-standard',
      },
      {
        label: 'Dropdowns',
        to: '/elements/dropdowns',
      },
      {
        label: 'Icons',
        to: '/elements/icons',
      },
      {
        label: 'Badges',
        to: '/elements/badges-labels',
      },
      {
        label: 'Cards',
        to: '/elements/cards',
      },
      {
        label: 'List Groups',
        to: '/elements/list-group',
      },
      {
        label: 'Navigation Menus',
        to: '/elements/navigation',
      },
      {
        label: 'Utilities',
        to: '/elements/utilities',
      },
    ],
  },
  {
    icon: 'pe-7s-car',
    label: 'Components',
    content: [
      {
        label: 'Tabs',
        to: '/components/tabs',
      },
      {
        label: 'Notifications',
        to: '/components/notifications',
      },
      {
        label: 'Modals',
        to: '/components/modals',
      },
      {
        label: 'Progress Bar',
        to: '/components/progress-bar',
      },
      {
        label: 'Tooltips & Popovers',
        to: '/components/tooltips-popovers',
      },
      {
        label: 'Carousel',
        to: '/components/carousel',
      },
      {
        label: 'Maps',
        to: '/components/maps',
      },
    ],
  },
  {
    icon: 'pe-7s-display2',
    label: 'Regular Tables',
    to: '/tables/regular-tables',
  },
];
export const FormsNav = [
  {
    icon: 'pe-7s-light',
    label: 'Controls',
    to: '/forms/controls',
  },
  {
    icon: 'pe-7s-eyedropper',
    label: 'Layouts',
    to: '/forms/layouts',
  },
  {
    icon: 'pe-7s-pendrive',
    label: 'Validation',
    to: '/forms/validation',
  },
];
export const WidgetsNav = [
  {
    icon: 'pe-7s-graph2',
    label: 'Dashboard Boxes',
    to: '/widgets/chart-boxes-3',
  },
];
export const ChartsNav = [
  {
    icon: 'pe-7s-graph2',
    label: 'ChartJS',
    to: '/charts/chartjs',
  },
];
